export default __webpack_public_path__ + "static/media/army_41.a86824a2.jpg";